import { useState, useRef, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  Col,
  Row,
  Dropdown,
  Modal,
} from "react-bootstrap";
import imgs from "../../Utils/assets/img/faces/5.jpg";
// import imgs from "../../"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Solid icons
import {
  faEnvelope,
  faMessage,
  faPhone,
  faQuestionCircle,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";

import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

import {
  FaWhatsapp,
} from "react-icons/fa";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import {
  PutRequest,
  GetRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { toast } from "sonner";
import "../detailPage/activity.css";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
} from "chart.js";

import { EmailModal } from "../detailPage/leads/EmailModal";
import { WhatsappModal } from "../../CommonComponents/WhatsappModal";
import { baseURL } from "../../Utils/constants/constant";
import {
  checkTwilioIntegration,
  formatDate,
  getMobileNumberByType,
  getValueOrPlaceHolder,
} from "../../Utils/helpers/commonhelper";
import { ContactActivity } from "../../CommonComponents/ContactActivity";
import GlobalCallModal from "../ivr/GlobalCallModal";
import TwilioIntegrationForm from "../ivr/TwilioIntegrationForm";
import DyanmicCallLog from "../ivr/DynamicCallLog";
import { DealDetailsCard } from "./DealDetailsComp/DealDetailsCard";
import { QuotationDetailsCard } from "./DealDetailsComp/QuotationDetailsCard";
import { PersonalDealDetails } from "./DealDetailsComp/PersonalDealDetails";
import { DealActivityPanel } from "./DealDetailsComp/DealActivityPanel";
import { useOutsideClickHandler } from "../../Utils/hooks/useOutsideClickHandler";
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials";
import { DetailsSkeleton } from "../../Utils/skeletonLoader/DetailsSkeleton";
import { useLocation, useSearchParams } from "react-router-dom";
import { useSharedPipelinePermission } from "../../Utils/hooks/usePipelineSharedPermission";

ChartJS.register(Legend, CategoryScale, LinearScale, PointElement, LineElement);

export const DealDetails = ({
  show,
  setrefetchDealsData,
  onClose,
  // dealId,
  pipelineStageData,
  refetchDeals,
  // canEdit,
  setSelectedStageId
}) => {
  // Session and navigation
  const { customer, headers, extras, customerId, loginUserId: loginId, userType } = useGetEssentials()

  const location = useLocation()
  const [searchParams] = useSearchParams()
  const locationData = location.state || null;
  const dealId = locationData?.id || searchParams.get("currDealId") || null
  const navigationPipelineId = locationData?.pipeline_id || searchParams.get("currPipelineId") || null

  // const [customer, setCustomer] = useLocalStorageState("customer");
  const [PERMISSION, _] = useLocalStorageState('permission')

  // for lead status info dropdown
  const [isInfoHovered, setInfoHovered] = useState(false)
  const statusDetails = [
    { label: 'Unqualified', description: "These leads you can keep it for later follow-ups. Currently, due to certain circumstances if requirements are not matching and can be fullfilled later." },
    { label: 'Lost', description: "Leads which are marked as LOST, follow-up across these leads do not come under pending follow-up section." },
  ]

  // permission setup for deals
  const dealGrant = PERMISSION.deals

  const [dealDetailsData, setDealDetails] = useState(null)
  const selectedPipelineId = navigationPipelineId || dealDetailsData?.pipeline_id || null
  const [dealsPipelineStages, setDealsPiplelineStages] = useState([])

  const [dealInitializing, setDealsInitializing] = useState(false)

  // Pipeline state management
  const [selectedStep, setSelectedStep] = useState(null);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [selectedStage, setSelectedStage] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [reason, setReason] = useState("");

  // // Dropdown state for three dots menu
  const [showDealStatusDropdown, setShowDealStatusDrop] = useState(false);
  // const actionsDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const [callLogOpen, setCallLogOpen] = useState(false);
  // previous stage tracking state
  const [previouslyCurrentStages, setPreviouslyCurrentStages] = useState(
    new Set(),
  );
  // Email modal state
  const [showEmailModal, setShowEmailModal] = useState(false);

  // WhatsApp modal state
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);

  // // Other state
  const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
  const [globalDiller, setGlobalDiller] = useState(false);
  const [showtwilioModal, setShowTwilioModal] = useState(false);

  // Close dropdowns for status on outside click
  useOutsideClickHandler({
    objRef: statusDropdownRef,
    isDropdown: showDealStatusDropdown,
    setDropdown: setShowDealStatusDrop
  })

  // Handles opening email modal
  const handleOpenEmailModal = () => {
    setShowEmailModal(true);
  };

  // Handles closing email modal
  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
  };

  // Check WhatsApp integration before opening modal
  const checkWhatsappIntegration = async () => {
    setShowWhatsappModal(true);
  };

  // Handles opening WhatsApp modal with integration check
  const handleOpenWhatsappModal = () => {
    checkWhatsappIntegration();
  };

  // Toggles status dropdown menu
  const toggleStatusDropdown = () => {
    if (!canEdit) {
      toast.warning("You are not a shared pipeline user. You are not authorized for this action!")
      return;
    }
    setShowDealStatusDrop((prev) => !prev);
  };

  // Closes status dropdown
  const closeStatusDropdown = () => setShowDealStatusDrop(false);;

  // const [currencyOpt, setCurrencyOpt] = useState([]);

  const handleMakeCurrentStage = async (stageId) => {
    if (!canEdit) {
      toast.warning("You are not a shared pipeline user. You are not authorized for this action!")
      return;
    }
    if (!dealDetailsData || !stageId || stageId === currentActiveStageId) return;

    const payload = {
      stage_id: stageId,
      deal_id: dealDetailsData.id,
      customer_id: customerId,
      pipeline_id: dealDetailsData.pipeline_id,
      user_login_id: loginId,
    };

    try {
      const response = await PutRequest(
        "deals/changeDealStage/",
        payload,
        { headers },
        extras,
      );
      if (response?.status === "success") {
        toast.success("Pipeline stage updated successfully");

        // Add the previous current stage to the set of previously current stages
        setPreviouslyCurrentStages((prev) => {
          const newSet = new Set(prev);
          if (currentActiveStageId) {
            newSet.add(currentActiveStageId);
          }
          return newSet;
        });

        setSelectedStage(null);
        closeWithAnimation();
        fetchDealDetails();
      } else {
        toast.error(response?.message || "Failed to update pipeline stage");
      }
    } catch (error) {
      toast.error("An error occurred while updating pipeline stage");
    }
  };

  // Handles lead status change with confirmation dialogs
  const handleStatusChange = async (status) => {
    if (!dealDetailsData) return;

    if (status === "won") {
      setConfirmAction({ type: "status", status, needsReason: false });
      setShowDealStatusDrop(false)
      setShowConfirmDialog(true);
    } else if (status === "unqualified" || status === "lost") {
      setConfirmAction({ type: "status", status, needsReason: true });
      setShowDealStatusDrop(false)
      setShowConfirmDialog(true);
    }
  };

  // Executes the confirmed status change
  const executeStatusChange = async () => {
    if (!confirmAction || !dealDetailsData) return;

    const payload = {
      deal_id: dealId,
      customer_id: customerId,
      deal_status: confirmAction.status,
      reason: confirmAction.needsReason ? reason : "",
      user_login_id: loginId,
    };
    try {
      const response = await PutRequest(
        "deals/changeDealStatus/",
        payload,
        { headers },
        extras,
      );
      if (response?.status === "success") {
        toast.success(`Deal Status Updated To ${confirmAction.status}`);
        closeStatusDropdown();
        setShowConfirmDialog(false);
        setConfirmAction(null);
        // setrefetchDealsData(true);
        // onClose();
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      toast.error("An error occurred while updating lead status");
    }
  };

  // fetching shared pipeline permissions for the current selected pipline
  const { permissionAssigned, canEdit } = useSharedPipelinePermission(
    selectedPipelineId,
    customerId,
    loginId,
    userType,
    headers,
    extras,
    'deals')

  // for calling
  const handleGlobalCallChange = () => {
    setGlobalDiller(false);
  };

  const checkTwilio = async () => {
    if (isCheckingTwilio) return;
    setIsCheckingTwilio(true);
    try {
      const res = await checkTwilioIntegration(customerId, headers, extras);
      if (res.status === "fail" || res.success === false) {
        setShowTwilioModal(true);
      }
      if (res.status === "success") {
        setGlobalDiller(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsCheckingTwilio(false);
    }
  };

  // Closes confirmation dialog
  const closeConfirmDialog = () => {
    setShowConfirmDialog(false);
    setConfirmAction(null);
    setReason("");
  };

  // Handles pipeline step animation close
  const closeWithAnimation = () => {
    setIsAnimatingOut(true);
    setTimeout(() => {
      setSelectedStep(null);
      setIsAnimatingOut(false);
    }, 300);
  }
  // Fetch lead details using the API
  const fetchDealDetails = async () => {
    try {
      setDealsInitializing(true);
      if (!dealId) {
        setDealDetails(null);
        setDealsInitializing(false);
        return;
      }
      const res = await GetRequest(`deals/getDealDetails/${dealId}/${customerId}/${loginId}`, { headers }, extras)
      if (res.status === 'fail' || res.success === false) {
        setDealDetails(null);
        setDealsInitializing(false);
        return
      }
      const dealData = res?.data ?? null;
      setDealDetails(dealData);
      setDealsInitializing(false);
    } catch (error) {
      return
    }
  }
  useEffect(() => {
    fetchDealDetails()
  }, [dealId])

  // Fetch pipeline stages for selected pipeline
  const fetchPipelineStage = async () => {
    if (!selectedPipelineId) return

    const pipelineStageUrl = selectedPipelineId
      ? `lead/fetchPipelineStage/${selectedPipelineId}/${customerId}`
      : null;

    try {
      const res = await GetRequest(pipelineStageUrl, { headers }, extras)
      if (res.status === 'fail' || res.success === false) {
        setDealsPiplelineStages([])
        return
      }
      if (res?.data?.length > 0) {
        const stageDataToStore = res.data.map((s) => ({
          value: s.id,
          label: s.stage_name,
        }));
        setDealsPiplelineStages(stageDataToStore);
      } else {
        setDealsPiplelineStages([]);
      }
    } catch (error) {
      return
    }
  }
  useEffect(() => {
    fetchPipelineStage()
  }, [selectedPipelineId])

  // Find current active stage based on pipeline_stage_id
  const currentActiveStage = dealsPipelineStages?.find(
    (stage) => stage.value === dealDetailsData?.pipeline_stage_id,
  );
  const currentActiveStageId = currentActiveStage?.value;

  // Show loading state
  if (dealInitializing) {
    return <DetailsSkeleton />
  }

  return (
    <div
      className="d-flex w-100"
      style={{ height: "calc(100vh - 5.5rem)", overflow: "hidden" }}
    >
      <div
        className="h-100 pt-4 w-100"
        style={{ borderRadius: "15px", background: "#f9f9f9", overflow: "hidden" }}
      >
        <Row className="ms-0 w-100 h-100 pe-2 ps-2" style={{ minHeight: 0 }}>
          <Col
            md={7}
            style={{
              height: "100%",
              minHeight: 0,
              overflow: "auto",
              borderRadius: "5px",
              borderRight: "1px solid #e0e4f8",
              borderTop: "none",
            }}
            className="pt-0 detailsDivs p-0"
          >
            <div
              className="me-0 pe-2"
              style={{
                background: "transparent",
                paddingTop: "0px",
                borderRadius: "0px",
                marginBottom: "10px",
              }}
            >
              {/* Header Section with Lead Info */}
              <div
                className="d-flex gap-3 align-items-center ps-3 mb-0 me-1"
                style={styles.stickyHeader}
              >
                <div>
                  <div
                    className="rounded-circle overflow-hidden border border-3 d-flex justify-content-center align-items-center"
                    style={{
                      width: "70px",
                      height: "70px",
                      backgroundColor: "#fff",
                      borderColor: "#7a3a5e",
                    }}
                  >
                    <img
                      src={
                        dealDetailsData?.contact_image
                          ? `${baseURL}${dealDetailsData.contact_image}`
                          : imgs
                      }
                      alt=""
                      className="w-100 h-100"
                      style={{ borderRadius: "50%" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    color: "#576f91",
                    fontSize: "13px",
                    fontWeight: 500,
                    width: "-webkit-fill-available",
                  }}
                  className="d-flex justify-content-between pe-3"
                >
                  <div>
                    <h4
                      className="mb-1"
                      style={{
                        fontSize: "20px",
                        fontWeight: "500",
                        color: "#3c3c3c",
                      }}
                    >
                      {getValueOrPlaceHolder(dealDetailsData?.deal_name)}
                      <span style={{ color: "#3f97fd" }}>({dealDetailsData?.deal_no && "#"}{`${getValueOrPlaceHolder(dealDetailsData?.deal_no)}`})
                      </span>
                      <span
                        style={{
                          color: "#FFC107",
                          fontSize: 13,
                          marginLeft: 7,
                        }}
                      >
                        {[...Array(5)].map((_, index) => {
                          const rating = dealDetailsData?.rating || 0;
                          if (rating >= index + 1) {
                            return <FaStar key={index} />;
                          } else if (rating >= index + 0.5) {
                            return <FaStarHalfAlt key={index} />;
                          } else {
                            return <FaRegStar key={index} />;
                          }
                        })}
                      </span>
                    </h4>
                    <p className="mb-0 d-flex align-items-center ">
                      {dealDetailsData?.total_budget && "₹"}{getValueOrPlaceHolder(dealDetailsData?.total_budget, "No Budget")}
                    </p>
                  </div>
                  <div className="d-flex flex-column position-relative">
                    <div
                      className="d-flex gap-1"
                      style={{ marginTop: "-12px" }}
                    >
                      <Tooltip title="Send WhatsApp" placement="top">
                        <button
                          type="button"
                          className="btn btn-whatsapp p-2"
                          style={styles.listWhatsButtonsStyles}
                          onClick={handleOpenWhatsappModal}
                        >
                          <FaWhatsapp style={{ fontSize: "16px" }} />
                        </button>
                      </Tooltip>
                      <div style={styles.emptyDivs}></div>
                      <Tooltip title="Send Mail" placement="top">
                        <button
                          type="button"
                          className="btn btn-primary btnss"
                          style={styles.listWhatsButtonsStyles}
                          onClick={handleOpenEmailModal}
                        >
                          <FontAwesomeIcon
                            icon={faEnvelope}
                            style={styles.iconStyles}
                          />
                        </button>
                      </Tooltip>
                      <Tooltip title="Call" placement="top">
                        <button
                          type="button"
                          className="btn btn-primary btnss"
                          style={styles.listWhatsButtonsStyles}
                          onClick={() => checkTwilio()}
                        >
                          <FontAwesomeIcon
                            icon={faPhone}
                            style={styles.iconStyles}
                          />
                        </button>
                      </Tooltip>
                      <Tooltip title="Send SMS" placement="top">
                        <button
                          type="button"
                          className="btn btn-primary btnss"
                          style={styles.listWhatsButtonsStyles}
                        >
                          <FontAwesomeIcon
                            icon={faMessage}
                            style={styles.iconStyles}
                          />
                        </button>
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: "1.2rem",
                        right: "0rem",
                        fontSize: "2.5rem",
                        color: "#c4c1c1",
                        fontWeight: 400,
                      }}
                    >
                      DEAL
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="my-3 bg-white me-1"
                style={{
                  border: "1px solid rgb(224, 228, 248)",
                  borderRadius: 4,
                  padding: 13,
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <h5
                    style={{ fontWeight: 300, fontSize: 19 }}
                    className="mb-0"
                  >
                    <p className="mb-1 fs-19" style={styles.labels}>
                      Current Pipeline
                    </p>{" "}
                    {getValueOrPlaceHolder(dealDetailsData?.pipeline_name)}{" "}
                  </h5>
                  <div
                    ref={statusDropdownRef}
                    className="mb-0 position-relative d-flex align-items-baseline">

                    <button
                      className="btn-default btn d-flex gap-2"
                      style={{ fontSize: 12, borderRadius: 3, textTransform: "capitalize" }}
                      onClick={toggleStatusDropdown}
                    >
                      {dealDetailsData?.deal_status &&
                        dealDetailsData.deal_status !== "inprogress" ?
                        getValueOrPlaceHolder(dealDetailsData.deal_status)
                        : "Select Deal Status"}
                      <FontAwesomeIcon icon={faSortDown} />
                    </button>
                    {showDealStatusDropdown && (
                      <div
                        className="defaultDropdown dropdown-menu"
                        style={{
                          width: "10rem",
                          padding: "7px 0px",
                          display: "block",
                          position: "fixed",
                          top:
                            statusDropdownRef.current?.getBoundingClientRect()
                              .bottom + window.scrollY || 0,
                          left:
                            statusDropdownRef.current?.getBoundingClientRect()
                              .right -
                            189 +
                            window.scrollX || 0,
                          zIndex: 9999,
                          backgroundColor: "#fff",
                          border: "1px solid #dee2e6",
                          borderRadius: "0.375rem",
                          boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
                        }}
                      >
                        <Dropdown.Item
                          onClick={() => {
                            if (!dealGrant.isEdit) {
                              toast.warning(
                                "You are not authorized for this action!",
                              );
                              return;
                            }
                            handleStatusChange("won");
                          }}
                          className="fs-13 d-flex gap-2 align-items-center"
                        >
                          <i
                            className="fa-solid fa-circle-check"
                            style={{ color: "#00b894" }}
                          ></i>{" "}
                          Won
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            if (!dealGrant.isEdit) {
                              toast.warning(
                                "You are not authorized for this action!",
                              );
                              return;
                            }
                            handleStatusChange("unqualified");
                          }}
                          className="fs-13 d-flex gap-2 align-items-center"
                        >
                          <i
                            className="fa-solid fa-circle-xmark"
                            style={{ color: "#d63031" }}
                          ></i>{" "}
                          Unqualified
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            {
                              if (!dealGrant.isEdit) {
                                toast.warning(
                                  "You are not authorized for this action!",
                                );
                                return;
                              }
                              handleStatusChange("lost");
                            }
                          }}
                          className="fs-13 d-flex gap-2 align-items-center"
                        >
                          <i
                            className="fa-solid fa-circle-exclamation"
                            style={{ color: "#fdcb6e" }}
                          ></i>{" "}
                          Lost
                        </Dropdown.Item>
                      </div>
                    )}

                    <div
                      className="position-relative"
                      onMouseEnter={() => setInfoHovered(true)}
                      onMouseLeave={() => setInfoHovered(false)}
                    >
                      <button
                        type="button"
                        className="btn p-1 text-muted shadow-none line-height-1"
                        style={{ transition: "color 0.15s ease" }}
                      >
                        <FontAwesomeIcon
                          icon={faQuestionCircle}
                          style={{ fontSize: "1.2rem" }}
                        />
                      </button>

                      {isInfoHovered && (
                        <div
                          className="position-absolute"
                          style={{
                            top: "110%",
                            right: 0,
                            width: "320px",
                            background: "#fff",
                            border: "1px solid #e0e4f8",
                            borderRadius: "8px",
                            padding: "12px",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                            zIndex: 1000,
                          }}
                        >
                          <h6
                            style={{
                              marginBottom: "10px",
                              color: "#7a3a5e",
                              fontWeight: 600,
                              fontSize: "13px",
                            }}
                          >
                            Lead Status Guide
                          </h6>

                          {statusDetails.map((c) => (
                            <div
                              key={c.label}
                              style={{
                                marginBottom: "10px",
                                paddingBottom: "10px",
                                borderBottom: "1px solid #f1f3f8",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "13px",
                                  fontWeight: 600,
                                  color: "#2e384d",
                                  marginBottom: "4px",
                                }}
                              >
                                {c.label}
                              </div>

                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#6b7280",
                                  lineHeight: 1.5,
                                }}
                              >
                                {c.description}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <hr />

                <div className="arrow-steps">
                  {dealsPipelineStages?.map((stage, index) => {
                    const isActive = stage.value === currentActiveStageId;
                    const isClicked = selectedStage?.value === stage.value;
                    const wasPreviouslyCurrent =
                      previouslyCurrentStages.has(stage.value);

                    let backgroundColor = ""; // Default gray for inactive stages
                    let textColor = "#000"; // Default text color

                    if (isActive) {
                      backgroundColor = "#7a3a5e"; // Purple for active
                      textColor = "#fff";
                    } else if (isClicked) {
                      backgroundColor = "#7a3a5e"; // Purple for clicked
                      textColor = "#fff";
                    } else if (wasPreviouslyCurrent) {
                      backgroundColor = "#28a745"; // Green for previously current stages
                      textColor = "#fff";
                    }

                    return (
                      <div
                        key={stage.value}
                        className={`step ${isActive ? "current" : ""}`}
                        onClick={() => {
                          setSelectedStage(stage);
                        }}
                        style={{
                          backgroundColor,
                          color: textColor,
                          cursor: "pointer",
                        }}
                      >
                        {stage.label}
                      </div>
                    );
                  })}
                </div>
                {selectedStage && (
                  <div
                    className={`d-flex align-items-start bg-white animated-fade-in ${isAnimatingOut ? "fade-out" : "fade-in"}`}
                    style={{ marginTop: 10, padding: "14px 6px" }}
                  >
                    <div
                      className="d-flex gap-3 ps-2"
                      style={{ width: "83%" }}
                    >
                      <div style={{ minWidth: "120px" }}>
                        <p
                          className="mb-0 text-nowrap"
                          style={styles.labels}
                        >
                          Stage name
                        </p>
                        <p className="mb-0" style={styles.values}>
                          {selectedStage?.label}
                        </p>
                      </div>
                      <div style={{ minWidth: '120px' }}>
                        <p className="mb-0 text-nowrap" style={styles.labels}>
                          Updated On
                        </p>
                        <p className="mb-0" style={styles.values}>
                          {getValueOrPlaceHolder(formatDate(dealDetailsData?.updated_at?.split(" ")[0]))}
                        </p>
                      </div>
                    </div>
                    {selectedStage?.value !== currentActiveStageId && (
                      <button
                        className="btn btn-default me-0"
                        style={{
                          fontSize: "13px",
                          textWrap: "nowrap",
                          color: "#fff",
                        }}
                        onClick={() => {
                          if (!dealGrant?.isEdit) {
                            toast.warning("You are not authorized for this action!",);
                            return;
                          }
                          if (!canEdit) {
                            toast.warning("You are not a shared pipeline user. You are not authorized for this action!")
                            return;
                          }
                          const selectedStageData = dealsPipelineStages.find(
                            (stage) => stage.value === selectedStage.value,
                          );
                          if (selectedStageData) {
                            handleMakeCurrentStage(selectedStageData?.value);
                          }
                        }}
                      >
                        Make as Current
                      </button>
                    )}
                  </div>
                )}
              </div>

              <div
                style={{ marginTop: 10 }}
                className="d-flex gap-2 align-items-stretch"
              >
                {/* Left Column - Personal Details */}
                {/* contact, company, internal and social details of the associated contact to deal */}
                <PersonalDealDetails
                  dealData={dealDetailsData}
                />

                {/* Right Column - Pipeline, Chart, History */}
                <div
                  style={{
                    height: "100%",
                    width: "50%",
                    position: "relative",
                  }}
                  className="pt-0 p-0 pe-1"
                >

                  {/* deal details */}
                  <DealDetailsCard dealData={dealDetailsData} />

                  {/* Quotation Details */}
                  <QuotationDetailsCard dealData={dealDetailsData} dealId={dealId} headers={headers} extras={extras} customerId={customerId} />

                  {/* History Section - Keep existing */}
                  <div
                    className="mt-3"
                    style={{
                      background: "#fff",
                      border: "1px solid rgb(224, 228, 248)",
                      borderRadius: 5,
                      height: "38.5rem",
                    }}
                  >
                    <h3
                      style={styles.sectionTitle}
                      className="d-flex mt-3 justify-content-between align-items-center"
                    >
                      History
                    </h3>
                    <hr className="my-2" />
                    <div
                      style={{ paddingLeft: "15px", paddingTop: "15px" }}
                    >

                      {dealDetailsData?.id && <ContactActivity
                        module_id={dealDetailsData?.id}
                        module_name={"deal"}
                        headers={headers}
                        extras={extras}
                      />}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>

          {/* Right Panel - Tabs Section */}
          <DealActivityPanel
            headers={headers}
            extras={extras}
            // onClose={onClose}
            // dealGrant={dealGrant}
            individualDealData={dealDetailsData}
            dealId={dealId}
            canEdit={canEdit}
            setCallLogOpen={setCallLogOpen}
            refetchDealDetails={fetchDealDetails}
            refetchDeals={refetchDeals}
            // setSelectedStageId={setSelectedStageId}
            isActionDropReqd={true}
          />
        </Row>
      </div>

      {/* Email Modal */}
      <EmailModal
        show={showEmailModal}
        onClose={handleCloseEmailModal}
        id={dealId}
        pipelineId={dealDetailsData?.pipeline_id}
        customerId={customerId}
        loginId={loginId}
        headers={headers}
        extras={extras}
        data={dealDetailsData} // Pass lead data for pre-populating emails
      />
      {/* WhatsApp Modal */}
      {
        showWhatsappModal && (
          <WhatsappModal
            whatsappModalOpen={showWhatsappModal}
            setWhatsAppModalOpen={setShowWhatsappModal}
            id={dealId}
            module_name={"deals"}
          />
        )
      }

      {/* {modal for call log} */}
      {
        callLogOpen && (
          <DyanmicCallLog
            show={callLogOpen}
            onCloseModal={() => setCallLogOpen(false)}
            module_id={dealId}
            module_name={"deal"}
          />
        )
      }
      {
        showtwilioModal && (
          <TwilioIntegrationForm
            isOpen={showtwilioModal}
            onClose={() => setShowTwilioModal(false)}
          />
        )
      }
      {/* global */}
      {
        globalDiller && (
          <GlobalCallModal
            isOpen={globalDiller}
            customerId={customerId}
            loginUserId={loginId}
            phoneNumber={getMobileNumberByType(customer, dealDetailsData?.user_phone, "Mobile")}
            onClose={handleGlobalCallChange}
            module_name={"deal"}
            module_id={dealId}
          />
        )
      }
      {/* Confirmation Dialog Modal */}

      {
        showConfirmDialog && (
          <Modal
            show={true}
            onHide={closeConfirmDialog}
            centered
            backdrop="static"
            style={{ zIndex: 1055 }}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {confirmAction?.status === "won"
                  ? "Confirm Win"
                  : `Confirm ${confirmAction?.status}`}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="d-flex flex-column gap-3">
                <p className="mb-0">
                  {confirmAction?.status === "won" ? (
                    "This action cannot be undone. Are you sure?"
                  ) : (
                    <>
                      Are you sure you want to mark this lead as{" "}
                      <span className="text-capitalize fw-medium">
                        {confirmAction?.status}
                      </span>
                      ? This action cannot be undone.
                    </>
                  )}
                </p>

                {confirmAction?.needsReason && (
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Reason *</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      placeholder={`Please provide a reason for marking as ${confirmAction?.status}`}
                      required
                      style={{ resize: "vertical" }}
                      autoFocus
                    />
                  </div>
                )}
              </div>
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-end gap-2">
              <button
                className="btn btn-default-outline"
                onClick={closeConfirmDialog}
              >
                Cancel
              </button>
              <button
                className="btn btn-default"
                onClick={executeStatusChange}
                disabled={confirmAction?.needsReason && !reason.trim()}
              >
                Confirm
              </button>
            </Modal.Footer>
          </Modal>
        )
      }
    </div >
  );
};

const styles = {
  bottomP: {
    fontSize: 11,
  },
  bottomH4: {
    marginBottom: 2,
  },
  buttons: {
    color: "#fff",
    fontSize: "13px",
    height: "34px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  filterbuttons: {
    fontSize: "13px",
    height: "33px",
    width: "33px",
    maxHeight: 33,
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  listButtonsStyles: {
    fontSize: "18px",
    height: "34px",
    width: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  listWhatsButtonsStyles: {
    fontSize: "13px",
    height: "29px",
    gap: 5,
    width: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  navButtonsStyles: {
    fontSize: "15px",
    height: "34px",
    minWidth: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  iconStyles: {
    fontSize: 12,
    color: "#fff",
  },
  emptyDivs: {
    borderRight: "1px solid #E0E4F8",
    height: "35px",
    margin: "0px 2px",
  },
  DropdownItemsStyle: {
    fontSize: ".93re",
    letterSpacing: ".0386rem",
    fontWeight: 400,
    color: "#2e384d",
  },
  navLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  inActiveNavLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
    pointerEvents: "none",
  },
  tabContainer: {
    border: "1px solid #E0E4F8",
    borderRadius: "4px",
  },
  stickyHeader: {
    paddingBottom: "12px",
    paddingTop: "12px",
    position: "sticky",
    background: "#fff",
    top: "0px",
    background: "#fff",
    borderRadius: 0,
    borderBottom: "1px solid rgb(224, 228, 248)",
    borderTop: "1px solid rgb(224, 228, 248)",
    borderLeft: "1px solid rgb(224, 228, 248)",
    borderRight: "1px solid rgb(224, 228, 248)",
    zIndex: 1,
  },
  labels: {
    fontSize: "12px",
    color: "#B0BAC9",
    fontWeight: 400,
  },
  iconsStyles: {
    color: "#2656a8",
    border: "1px solid #e6e6e6",
    background: "#e9f1ff",
    padding: "8px",
    borderRadius: "50%",
    marginRight: "10px",
    width: "11px",
    height: "11px",
    fontSize: "13px",
  },
  values: {
    color: "#2e384d",
    fontWeight: 400,
    fontSize: ".8333rem",
    letterSpacing: "0.25px",
  },
  sectionTitle: {
    fontSize: "17px",
    fontWeight: 300,
    marginLeft: "14px",
    marginBottom: "19px",
  },
};


// const defaultd = { fullName: fullName, email: email, id: dealId }
